import React from 'react';
import {FormattedMessage} from 'react-intl';
import {useCustomerDetailsUIContext} from '../CustomerDetailsUIContext';
import ButtonAction from '../../../_common/components/ButtonAction';
import Divider from '../../../_common/components/Divider';

const EditPanel = () => {
  const {formik, updateCustomer} = useCustomerDetailsUIContext();
  const prefix = 'customer-details';

  return (
    <div className="w-100 d-flex align-items-center flex-column">
      <h5 className="text-dark font-weight-bold mb-2">
        {formik.values.firstName || ''}
      </h5>
      <h5 className="text-dark font-weight-bold mb-8">
        {formik.values.lastName || ''}
      </h5>
      <ButtonAction
        useIcon={'/media/common/Save-white.svg'}
        label={<FormattedMessage id={`${prefix}-subheader-save`} defaultMessage="Save changes"/>}
        disabled={!formik.isValid}
        onClick={() => updateCustomer()}
      />
      <Divider customClassNames={'my-8'}/>
    </div>
  );
};

export default EditPanel;
